import styled from 'styled-components';

export const ContainerStyled = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const WrapperStyled = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
`;

export const TitleStyled = styled.h3`
  flex: 1;
  white-space: nowrap;
  line-height: 1.6;
`;
